document.addEventListener("DOMContentLoaded", function() {
  const showTD = localStorage.getItem("bss-show-td");
  document.querySelector("body").setAttribute("showTD", showTD);
    if (window.location.pathname === "/" && !showTD) {
        document.getElementById("modal-bss").classList.add("show");
    }

    let clickVariant = document.querySelectorAll('.block-swatch')
    if (clickVariant.length) {
        clickVariant.forEach((e) => {
            e.addEventListener('click', () => {
                let price = document.querySelector('.price-list[bss-b2b-product-id]');
                if (price) {
                    price.classList.add('bss_custom')
                }
                setTimeout(() => {
                    if (price) {
                        price.classList.remove('bss_custom')
                    }
                }, 1000)

            })

        })
    }
});

function closeModal() {
    document.getElementById("modal-bss").classList.remove("show");
}

function selectOption(option) {
    localStorage.setItem("bss-show-td", option);
    document.querySelector("body").setAttribute("showTD", option);
    closeModal();
}

// document.getElementById("modal-bss").addEventListener("click", function(event) {
//     // if (event.target === this) {
//         closeModal();
//     // }
// });
